<template>
  <div class="coque" :class="{ 'menu-ouvert': menuOuvert }">
    <aside class="barre" aria-label="Menu principal">
      <div class="marque">
        <img src="/favicon.svg" alt="" width="34" height="34" />
        <div>
          <div class="marque-nom">{{ nomEntreprise }}</div>
          <div class="marque-sous">Boutique Pro</div>
        </div>
      </div>
      <nav>
        <template v-for="(g, i) in menu" :key="i">
          <div v-if="g.titre" class="groupe">{{ g.titre }}</div>
          <router-link v-for="l in g.liens" :key="l.nom" :to="{ name: l.nom }" class="lien" :class="{ vedette: l.vedette }" @click="menuOuvert = false">
            <i class="bi" :class="l.icone"></i><span>{{ l.libelle }}</span>
          </router-link>
        </template>
      </nav>
    </aside>
    <div class="voile" @click="menuOuvert = false"></div>

    <div class="principal">
      <header class="tete non-imprimable">
        <button class="btn btn-light d-lg-none" @click="menuOuvert = !menuOuvert" aria-label="Ouvrir le menu"><i class="bi bi-list"></i></button>

        <div v-if="!plateforme && sites.length" class="choix-site">
          <i class="bi bi-geo-alt"></i>
          <select v-if="sites.length > 1" :value="$store.state.siteId" @change="changerSite($event.target.value)" class="form-select form-select-sm" aria-label="Site de travail">
            <option v-for="s in sites" :key="s.id" :value="s.id">{{ s.nom }}{{ s.type === 'DEPOT' ? ' (dépôt)' : '' }}</option>
          </select>
          <span v-else class="fw-semibold">{{ sites[0].nom }}</span>
        </div>

        <div class="ms-auto d-flex align-items-center gap-2">
          <InstallerApplication />
          <button v-if="peutCaisse" class="btn btn-sm bouton-caisse" :class="caisse ? 'ouverte' : ''" @click="afficherCaisse = true">
            <i class="bi" :class="caisse ? 'bi-unlock-fill' : 'bi-lock-fill'"></i>
            <span v-if="caisse"><span class="d-none d-sm-inline">Caisse ouverte · </span><span class="chiffre">{{ fcfa(caisse.especesAttendues) }}</span></span>
            <span v-else>Ouvrir<span class="d-none d-sm-inline"> ma caisse</span></span>
          </button>
          <div class="dropdown">
            <button class="btn btn-sm btn-light dropdown-toggle utilisateur" data-bs-toggle="dropdown" aria-expanded="false">
              <span class="initiales">{{ initiales }}</span><span class="d-none d-md-inline">{{ nomUtilisateur }}</span>
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li><router-link class="dropdown-item" :to="{ name: 'compte' }"><i class="bi bi-person-circle me-2"></i>Mon compte</router-link></li>
              <li><hr class="dropdown-divider" /></li>
              <li><button class="dropdown-item text-danger" @click="deconnecter"><i class="bi bi-box-arrow-right me-2"></i>Se déconnecter</button></li>
            </ul>
          </div>
        </div>
      </header>

      <EtatHorsLigne v-if="!plateforme" />
      <div v-if="bandeau" class="bandeau" :class="bandeau.classe" role="status">
        <i class="bi bi-exclamation-triangle-fill"></i> {{ bandeau.texte }}
        <router-link v-if="$store.getters.hasPermission('ABONNEMENT_GERER')" :to="{ name: 'mon_abonnement' }">Renouveler</router-link>
      </div>
      <div v-if="!plateforme && entrepriseChargee && !sites.length && $store.getters.hasPermission('PARAMETRES_GERER')" class="bandeau bandeau-info">
        Créez votre première boutique pour commencer à vendre. <router-link :to="{ name: 'parametres' }">Créer un site</router-link>
      </div>

      <main><router-view /></main>
    </div>

    <MaCaisse v-if="afficherCaisse" @fermer="afficherCaisse = false" />
  </div>
</template>

<script>
import MaCaisse from "@/components/caisse/MaCaisse.vue";
import InstallerApplication from "@/components/commun/InstallerApplication.vue";
import EtatHorsLigne from "@/components/commun/EtatHorsLigne.vue";
import { MENU, MENU_PLATEFORME } from "./menu";
import { fcfa } from "@/utils/format";
import { surveillerInactivite, arreterSurveillance } from "@/surveillance/inactivite";

export default {
  name: "MainLayout",
  components: { MaCaisse, InstallerApplication, EtatHorsLigne },
  data: () => ({ menuOuvert: false, afficherCaisse: false }),
  computed: {
    plateforme() { return this.$store.getters.isPlatformAdmin; },
    entrepriseChargee() { return !!this.$store.state.user?.entreprise; },
    sites() { return this.$store.state.sites; },
    caisse() { return this.$store.state.caisse; },
    peutCaisse() { return !this.plateforme && this.$store.getters.hasAnyPermission(["VENTE_CAISSE", "CAISSE_OUVRIR"]); },
    nomEntreprise() { return this.plateforme ? "Plateforme" : (this.$store.state.user?.entreprise?.nom || "Ma boutique"); },
    nomUtilisateur() { const u = this.$store.state.user; return u ? `${u.prenom || ""} ${u.nom || ""}`.trim() : ""; },
    initiales() { const u = this.$store.state.user; return ((u?.prenom || " ")[0] + (u?.nom || " ")[0]).toUpperCase(); },
    menu() {
      if (this.plateforme) return MENU_PLATEFORME;
      const g = this.$store.getters;
      return MENU.map(groupe => ({
        ...groupe,
        liens: groupe.liens.filter(l => (!l.module || g.hasModule(l.module)) && (!l.permissions || g.hasAnyPermission(l.permissions)))
          .filter(l => l.nom !== "transferts" || this.sites.length > 1 || g.isSuperAdmin)
      })).filter(groupe => groupe.liens.length);
    },
    bandeau() {
      const e = this.$store.state.user?.entreprise;
      if (!e || e.joursRestants === null || e.joursRestants === undefined) return null;
      if (e.joursRestants < 0) return { classe: "bandeau-rouge", texte: `L'abonnement a expiré il y a ${-e.joursRestants} jour(s). L'accès sera coupé à la fin du délai de grâce.` };
      if (e.joursRestants <= 7) return { classe: "bandeau-ambre", texte: `L'abonnement se termine dans ${e.joursRestants} jour(s).` };
      return null;
    }
  },
  mounted() {
    surveillerInactivite(() => {
      this.$store.dispatch("logout");
      this.$router.push({ path: "/login", query: { message: "Déconnecté après une longue inactivité." } });
    }, 60);
  },
  beforeUnmount() { arreterSurveillance(); },
  methods: {
    fcfa,
    changerSite(id) {
      this.$store.commit("setSite", Number(id));
    },
    deconnecter() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
.coque { display: flex; min-height: 100vh; }
.barre { width: 248px; flex-shrink: 0; background: var(--indigo-900); color: #c9cfee; position: sticky; top: 0; height: 100vh; overflow-y: auto; padding: 14px 12px 24px; z-index: 1030; }
.marque { display: flex; align-items: center; gap: 10px; padding: 4px 8px 16px; border-bottom: 1px solid rgba(255,255,255,.08); margin-bottom: 8px; }
.marque-nom { color: #fff; font-weight: 700; line-height: 1.15; max-width: 170px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.marque-sous { font-size: .75rem; color: #8f97c7; }
.groupe { font-size: .75rem; color: #8189bd; padding: 16px 10px 5px; font-weight: 600; }
.lien { display: flex; align-items: center; gap: 11px; padding: 8px 10px; border-radius: 7px; color: #d3d8f3; text-decoration: none; font-size: .92rem; }
.lien i { font-size: 1.05rem; width: 20px; text-align: center; color: #8f99d6; }
.lien:hover { background: rgba(255,255,255,.06); color: #fff; }
.lien.router-link-active { background: var(--indigo-700); color: #fff; }
.lien.router-link-active i { color: #fff; }
.lien.vedette { background: var(--safran); color: var(--indigo-950); font-weight: 700; margin: 6px 0; }
.lien.vedette i { color: var(--indigo-950); }
.lien.vedette:hover { background: #edb53a; }
.principal { flex: 1; min-width: 0; display: flex; flex-direction: column; }
.tete { height: 56px; background: var(--papier); border-bottom: 1px solid var(--trait); display: flex; align-items: center; gap: 12px; padding: 0 20px; position: sticky; top: 0; z-index: 1020; }
.choix-site { display: flex; align-items: center; gap: 8px; color: var(--gris); }
.choix-site .form-select { min-width: 200px; font-weight: 600; color: var(--encre); }
.bouton-caisse { background: var(--fond); border: 1px solid var(--trait); color: var(--encre); font-weight: 600; }
.bouton-caisse.ouverte { background: var(--vert-clair); border-color: #bfe3cf; color: var(--vert); }
.utilisateur { display: flex; align-items: center; gap: 8px; }
.initiales { width: 28px; height: 28px; border-radius: 50%; background: var(--indigo-100); color: var(--indigo-800); font-weight: 700; font-size: .78rem; display: inline-flex; align-items: center; justify-content: center; }
.bandeau { padding: 9px 20px; font-weight: 500; display: flex; gap: 10px; align-items: center; }
.bandeau-rouge { background: var(--rouge-clair); color: var(--rouge); }
.bandeau-ambre { background: var(--ambre-clair); color: var(--ambre); }
.bandeau-info { background: var(--indigo-50); color: var(--indigo-800); }
.voile { display: none; }
@media (max-width: 991px) {
  .barre { position: fixed; left: 0; top: 0; transform: translateX(-100%); transition: transform .2s; }
  .menu-ouvert .barre { transform: none; }
  .menu-ouvert .voile { display: block; position: fixed; inset: 0; background: rgba(18,25,55,.4); z-index: 1025; }
  .choix-site .form-select { min-width: 140px; }
}
/* Téléphone */
@media (max-width: 575px) {
  .tete { padding: 0 10px; gap: 8px; }
  .choix-site > i { display: none; }
  .choix-site .form-select { min-width: 0; max-width: 130px; }
  .choix-site .fw-semibold { max-width: 110px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .bandeau { padding: 8px 12px; font-size: .88rem; flex-wrap: wrap; }
  .barre { width: 82vw; max-width: 300px; }
  .lien { padding: 11px 10px; }
}
/* Application installée sur iPhone : la barre d'état se superpose au haut de l'écran */
@supports (padding-top: env(safe-area-inset-top)) {
  .tete { padding-top: env(safe-area-inset-top); height: calc(56px + env(safe-area-inset-top)); }
  .barre { padding-top: calc(14px + env(safe-area-inset-top)); }
}
@media print { .barre, .tete, .bandeau { display: none !important; } }
</style>
